var changeLanguage = {
    methods: {
        changeLanguage (lang) {
            if (lang !== this.$route.params.locale) {
                switch (lang) {
                    case 'de':
                        this.$router.push({ name: 'section', params: { locale: lang, sectionSlug: 'home' }})
                        window.location.reload();
                        break;                    
                    case 'en':
                        
                        this.$router.push({ name: 'section', params: { locale: lang, sectionSlug: 'home' }})
                        window.location.reload();
                        break;
                }
            }
        }
    }
  }
  export {changeLanguage}